const section = {
  about: 'Tentang saya',
  projects: 'Proyek',
  blogs: 'Blog',
  skills: 'Kemampuan',
  contact: 'Hubungi saya 🤙',
};

export default section;
